import { render, staticRenderFns } from "./RealnameAuth.vue?vue&type=template&id=3738e5a1&scoped=true"
import script from "./RealnameAuth.vue?vue&type=script&lang=js"
export * from "./RealnameAuth.vue?vue&type=script&lang=js"
import style0 from "./RealnameAuth.vue?vue&type=style&index=0&id=3738e5a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738e5a1",
  null
  
)

export default component.exports